import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import { Result } from '../Result';
import type { ITransition } from '../../../stores/model/metamodel/transition';

/**
 * Check if a transition is consistent.
 *
 * Checks if:
 * - transition has at least 1 method
 *
 * JMermaid check also checked if:
 * - The transition had both a source and target state
 * - The transitions fsm is the same as the fsm of the source and target state
 * These inconsistencies are not possible in the new data model.
 */
class TransitionConsistencyCheck extends Check<ITransition> {
  static description = 'Check for transition consistency';

  check(): Report {
    this.report = new Report();

    if (this.element.methods.length === 0) {
      this.report.addMessage(
        MessageType.ERROR,
        'Transition does not have methods specified.',
        this,
        this.element
      );
    }

    if (this.report.result === Result.NO_RESULT) {
      this.report.addMessage(
        MessageType.INFORMATION,
        'Transition has methods specified.',
        this,
        this.element
      );
    }

    return this.report;
  }
}

export default TransitionConsistencyCheck;
